<template>
  <div>
    <md-dialog
      :closable="false"
      :btns="slotDialog.btns"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <ResultStatus type="success" size="114px" style="margin-bottom: 36px;" />
      <!-- <svg-icon name="success-face" class-name="success-icon" /> -->
      {{ contentext }}
    </md-dialog>
  </div>
</template>

<script>
// 激活认证结果
import { Dialog } from 'mand-mobile'
import { VERIFIED_STATUS } from '@/constants'
import ResultStatus from '@/components/ResultStatus'
import { fenToYanAndFormat } from '@/utils/format-amount'
export default {
  name: 'AcitvateResult',
  components: {
    [Dialog.name]: Dialog,
    ResultStatus
  },
  props: {
    levelType: {
      type: Number,
      default: null
    },
    amountData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      fenToYanAndFormat,
      contentext:
        '',
      slotDialog: {
        open: this.$attrs.value,
        btns: [
          {
            text: this.$t('raise_my_kyc_level'),
            handler: this.onBasicCancel
          },
          {
            text: this.$t('done'),
            handler: this.onBasicConfirm
          }
        ]
      }
    }
  },
  watch: {
    amountData (newVal) {
      // 高级低级认证成功显示弹框
      if (newVal) {
        if (this.levelType === VERIFIED_STATUS.HIGH) { // 高级
          this.contentext =
          this.$t('high__activation__success', { topUpMonthLimitAmount: this.fenToYanAndFormat(newVal.topUpMonthLimitAmount), withdrawMonthLimitAmount: this.fenToYanAndFormat(newVal.withdrawMonthLimitAmount), transferMonthLimitAmount: this.fenToYanAndFormat(newVal.transferMonthLimitAmount) })
          this.slotDialog.btns = [
            {
              text: this.$t('done'),
              handler: this.onBasicConfirm
            }
          ]
        } else { // 低级
          this.contentext =
          this.$t('low__activation__success', { topUpMonthLimitAmount: this.fenToYanAndFormat(newVal.topUpMonthLimitAmount), withdrawMonthLimitAmount: this.fenToYanAndFormat(newVal.withdrawMonthLimitAmount), transferMonthLimitAmount: this.fenToYanAndFormat(newVal.transferMonthLimitAmount) })
        }
      }
    }
  },
  methods: {
    onBasicCancel () {
      this.$listeners.input(false)
      this.$router.push({ name: 'ActivateHighLevel' })
    }
  }
}
</script>

<style lang='scss' scoped>
::v-deep .md-dialog-content {
  .md-dialog-body {
    padding: 60px 30px 39px;
    font-size: 28px;
    color: #333;
    line-height: 48px;
    text-align: center;

    .status-icon {
      width: 114px;
      height: 114px;
    }
  }
}
</style>
